document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-pickmix-root]');
  if (!root) return;

  var totalSteps = parseInt(root.getAttribute('data-total-steps') || '0', 10);
  var stepGrams = parseInt(root.getAttribute('data-step-grams') || '100', 10);
  var parentVariantId = parseInt(root.getAttribute('data-parent-variant-id') || '0', 10);
  var cartUrl = root.getAttribute('data-cart-url') || '/cart';

  var i18n = {
    empty: root.getAttribute('data-t-empty') || 'Nessun gusto selezionato.',
    complete: root.getAttribute('data-t-complete') || '% completo',
    missingPrefix: root.getAttribute('data-t-missing-prefix') || 'Ti mancano ',
    missingMiddle: root.getAttribute('data-t-missing-middle') || ' selezioni da ',
    mixComplete: root.getAttribute('data-t-mix-complete') || i18n.mixComplete,
    overLimit: root.getAttribute('data-t-over-limit') || i18n.overLimit,
    adding: root.getAttribute('data-t-adding') || i18n.adding,
    addCart: root.getAttribute('data-t-add-cart') || i18n.addCart,
    error: root.getAttribute('data-t-error') || i18n.error
  };

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-child-card]'));
  var pickedStepsEl = root.querySelector('[data-picked-steps]');
  var pickedGramsEl = root.querySelector('[data-picked-grams]');
  var progressBar = root.querySelector('[data-progress-bar]');
  var progressLabel = root.querySelector('[data-progress-label]');
  var messageEl = root.querySelector('[data-pickmix-message]');
  var summaryList = root.querySelector('[data-summary-list]');
  var addToCartBtn = root.querySelector('[data-pickmix-add]');

  if (!cards.length || !parentVariantId || !totalSteps) return;

  var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pickmix-filter]'));

  var brandDropdown = root.querySelector('[data-pickmix-brand-dropdown]');
  var brandCheckboxes = Array.prototype.slice.call(root.querySelectorAll('[data-pickmix-brand-checkbox]'));
  var brandLabel = root.querySelector('[data-pickmix-brand-label]');
  var activeTaste = 'all';

  function selectedBrands() {
    return brandCheckboxes.filter(function (box) { return box.checked; }).map(function (box) { return box.value; });
  }

  function applyFilter(filter) {
    activeTaste = filter;
    var brands = selectedBrands();
    cards.forEach(function (card) {
      var types = (card.getAttribute('data-pickmix-types') || '').split(/\s+/).filter(Boolean);
      var tasteMatches = filter === 'all' || types.indexOf(filter) !== -1;
      var brandMatches = !brands.length || brands.indexOf(card.getAttribute('data-pickmix-brand')) !== -1;
      card.classList.toggle('is-filter-hidden', !(tasteMatches && brandMatches));
    });
    filterButtons.forEach(function (button) {
      var active = button.getAttribute('data-pickmix-filter') === filter;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (brandLabel) {
      if (!brands.length) brandLabel.textContent = brandLabel.getAttribute('data-all-label');
      else if (brands.length === 1) {
        var single = brandCheckboxes.filter(function (box) { return box.checked; })[0];
        brandLabel.textContent = single.parentElement.querySelector('span').textContent.trim();
      } else brandLabel.textContent = brands.length + ' ' + brandLabel.getAttribute('data-count-label');
    }
  }

  filterButtons.forEach(function (button) {
    button.addEventListener('click', function () { applyFilter(button.getAttribute('data-pickmix-filter') || 'all'); });
  });
  brandCheckboxes.forEach(function (box) {
    box.addEventListener('change', function () { applyFilter(activeTaste); });
  });
  var clearBrands = root.querySelector('[data-pickmix-brand-clear]');
  if (clearBrands) clearBrands.addEventListener('click', function () {
    brandCheckboxes.forEach(function (box) { box.checked = false; });
    applyFilter(activeTaste);
  });
  var doneBrands = root.querySelector('[data-pickmix-brand-done]');
  if (doneBrands) doneBrands.addEventListener('click', function () { if (brandDropdown) brandDropdown.open = false; });
  if (brandDropdown) {
    document.addEventListener('click', function (event) {
      if (!brandDropdown.contains(event.target)) brandDropdown.open = false;
    });
    brandDropdown.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        brandDropdown.open = false;
        var trigger = brandDropdown.querySelector('summary');
        if (trigger) trigger.focus();
      }
    });
  }

  function sanitizeQty(value) {
    var qty = parseInt(value || '0', 10);
    if (isNaN(qty) || qty < 0) return 0;
    return qty;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getInput(card) {
    return card.querySelector('[data-qty-input]');
  }

  function getQtyWrap(card) {
    return card.querySelector('[data-qty-wrap]');
  }

  function getAddBtn(card) {
    return card.querySelector('[data-card-add]');
  }

  function getQty(card) {
    var input = getInput(card);
    if (!input) return 0;
    return sanitizeQty(input.value);
  }

  function setQty(card, qty) {
    var input = getInput(card);
    if (!input) return;
    input.value = String(Math.max(0, qty));
  }

  function getImageSrc(card) {
    var image = card.querySelector('.pickmix-card__image');
    return image ? image.getAttribute('src') : '';
  }

  function getSelections() {
    return cards
      .map(function (card) {
        return {
          title: card.getAttribute('data-title') || '',
          qty: getQty(card),
          image: getImageSrc(card)
        };
      })
      .filter(function (item) {
        return item.qty > 0;
      });
  }

  function getSelectedSteps() {
    return getSelections().reduce(function (sum, item) {
      return sum + item.qty;
    }, 0);
  }

  function getOtherSteps(currentCard) {
    return cards.reduce(function (sum, card) {
      if (card === currentCard) return sum;
      return sum + getQty(card);
    }, 0);
  }

  function syncCardState(card) {
  var qty = getQty(card);
  var qtyWrap = getQtyWrap(card);
  var addBtn = getAddBtn(card);

  if (!qtyWrap || !addBtn) return;

  if (qty > 0) {
    qtyWrap.style.display = 'grid';
    qtyWrap.classList.remove('is-hidden');
    addBtn.style.display = 'none';
    addBtn.classList.add('is-hidden');
  } else {
    qtyWrap.style.display = 'none';
    qtyWrap.classList.add('is-hidden');
    addBtn.style.display = 'inline-flex';
    addBtn.classList.remove('is-hidden');
  }
}

  function renderSummary(selections) {
    if (!summaryList) return;

    if (!selections.length) {
      summaryList.innerHTML = '<div class="pickmix-summary__empty">' + escapeHtml(i18n.empty) + '</div>';
      return;
    }

    summaryList.innerHTML = selections
      .map(function (item, index) {
        var thumb = item.image
          ? '<img class="pickmix-summary__thumb" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">'
          : '<div class="pickmix-summary__thumb"></div>';

        return (
          '<div class="pickmix-summary__item">' +
            '<div class="pickmix-summary__index">' + (index + 1) + '.</div>' +
            thumb +
            '<div class="pickmix-summary__name">' + escapeHtml(item.title) + '</div>' +
            '<div class="pickmix-summary__qty">x' + item.qty + '</div>' +
          '</div>'
        );
      })
      .join('');
  }

  function updateUI() {
    var selections = getSelections();
    var selectedSteps = getSelectedSteps();
    var grams = selectedSteps * stepGrams;
    var percent = Math.max(0, Math.min(100, Math.round((selectedSteps / totalSteps) * 100)));
    var remaining = totalSteps - selectedSteps;

    cards.forEach(syncCardState);

    if (pickedStepsEl) pickedStepsEl.textContent = String(selectedSteps);
    if (pickedGramsEl) pickedGramsEl.textContent = String(grams);
    if (progressBar) progressBar.style.width = percent + '%';
    if (progressLabel) progressLabel.textContent = percent + i18n.complete;

    if (remaining > 0) {
      if (messageEl) messageEl.textContent = i18n.missingPrefix + remaining + i18n.missingMiddle + stepGrams + 'g.';
      if (addToCartBtn) addToCartBtn.disabled = true;
    } else if (remaining === 0) {
      if (messageEl) messageEl.textContent = i18n.mixComplete;
      if (addToCartBtn) addToCartBtn.disabled = false;
    } else {
      if (messageEl) messageEl.textContent = i18n.overLimit;
      if (addToCartBtn) addToCartBtn.disabled = true;
    }

    renderSummary(selections);
  }

  function increase(card) {
    var currentQty = getQty(card);
    var otherSteps = getOtherSteps(card);
    var maxAllowed = Math.max(0, totalSteps - otherSteps);

    if (currentQty >= maxAllowed) {
      updateUI();
      return;
    }

    setQty(card, currentQty + 1);
    updateUI();
  }

  function decrease(card) {
    var currentQty = getQty(card);
    setQty(card, Math.max(0, currentQty - 1));
    updateUI();
  }

  cards.forEach(function (card) {
    var plusBtn = card.querySelector('[data-increase]');
    var minusBtn = card.querySelector('[data-decrease]');
    var addBtn = getAddBtn(card);
    var input = getInput(card);

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        increase(card);
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        increase(card);
      });
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        decrease(card);
      });
    }

    if (input) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(/[^\d]/g, '');
      });

      input.addEventListener('change', function () {
        var desired = sanitizeQty(input.value);
        var otherSteps = getOtherSteps(card);
        var maxAllowed = Math.max(0, totalSteps - otherSteps);
        var finalValue = Math.min(desired, maxAllowed);

        input.value = String(finalValue);
        updateUI();
      });
    }
  });

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function () {
      var selections = getSelections();
      var selectedSteps = getSelectedSteps();

      if (selectedSteps !== totalSteps || !selections.length) {
        updateUI();
        return;
      }

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = i18n.adding;

      var properties = {};

      selections.forEach(function (item, index) {
        properties['bundle_item_' + (index + 1)] = item.title + ' X ' + item.qty;
      });

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: parentVariantId,
              quantity: 1,
              properties: properties
            }
          ]
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw data;
            });
          }
          return response.json();
        })
        .then(function () {
          window.location.href = cartUrl;
        })
        .catch(function (error) {
          console.error('Pickmix error:', error);
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = i18n.addCart;
          if (messageEl) messageEl.textContent = i18n.error;
        });
    });
  }

  updateUI();
});

document.addEventListener('click', function(event) {
  var modal = document.querySelector('[data-pickmix-modal]');
  if (!modal) return;

  var openBtn = event.target.closest('[data-pickmix-modal-open]');
  var closeBtn = event.target.closest('[data-pickmix-modal-close]');
  var dialog = modal.querySelector('.pickmix-modal__dialog');

  if (openBtn) {
    var card = openBtn.closest('[data-child-card]');
    var template = card ? card.querySelector('[data-pickmix-modal-template]') : null;

    modal.querySelector('[data-pickmix-modal-title]').textContent =
      openBtn.getAttribute('data-title') || '';

    modal.querySelector('[data-pickmix-modal-content]').innerHTML =
      template ? template.innerHTML : '';

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    return;
  }

  if (modal.hidden) return;

  if (closeBtn || (dialog && !dialog.contains(event.target))) {
    modal.hidden = true;
    document.body.style.overflow = '';
  }
});